export const APP_KEY: string = 'PLANITEAM';
export const VERSION: string = '1.9.0';